<template>
	<div class="termregisterinfo">
       <div>
           {{list.title}}
       </div>

       <div>
           <div>
               <div>举办时间</div>
               <div>
                   {{list.starttime|moment('YYYY-MM-DD hh:mm')}}
               </div>
           </div>

           <div>
               <div>举办地点</div>
               <div>
                   {{list.address}}
               </div>
           </div>
           <div>
               <div>报名组别</div>
               <div>
                   {{list.typename}}
               </div>
           </div>

           <div v-if="list.notice">
               <div>报名条件</div>
               <div>
                   {{list.notice}}
               </div>
           </div>
       </div>
   </div>
</template>

<script>
	import './index.less'
	import moment from 'moment'
	export default {
        name: 'termnew',
        filters:{

        },
        props: {
            list: Object
        },
        methods:{
        },
        computed:{

        }
    }
</script>